import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

const SoftBadge = ({ style, bg = 'primary', pill, children, className }) => {
  return (
    <div
      className={classNames(className, `badge badge-soft-${bg}`, {
        'rounded-pill': pill,
      })}
      style={style}
    >
      {children}
    </div>
  );
};

SoftBadge.propTypes = {
  style: PropTypes.object,
  bg: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'info',
    'warning',
    'danger',
    'light',
    'dark',
  ]),
  pill: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default SoftBadge;
